var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-nav-menu"},[_c('div',{staticClass:"brand"},[_c('v-img',{attrs:{"src":_vm.brandImage,"contain":"","max-width":"200","height":"40"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }